export function miniAppProjectTarget(start?: string) {
  const match = start?.match(
    /^(project|ai|members|settings|activity|docs)_([a-zA-Z0-9-]{1,100})$/,
  );
  if (!match) return null;
  return {
    projectId: match[2],
    view:
      match[1] === "project"
        ? ("board" as const)
        : (match[1] as "ai" | "members" | "settings" | "activity" | "docs"),
  };
}

export function telegramBotLink(username: string, start = "home") {
  return `https://t.me/${username}?start=${encodeURIComponent(start)}`;
}

export interface BotStartTarget {
  view:
    "projects" | "tasks" | "ai" | "members" | "settings" | "activity" | "docs";
  projectId?: string;
  taskId?: string;
  documentId?: string;
  inviteCode?: string;
}

export function botStartTarget(start: string): BotStartTarget | null {
  if (start.length > 64) return null;
  if (start === "home") return { view: "projects" };
  if (start === "settings") return { view: "settings" };
  const task = start.match(/^task_([a-zA-Z0-9-]+)$/);
  if (task) return { view: "tasks", taskId: task[1] };
  const document = start.match(/^doc_([a-zA-Z0-9-]+)$/);
  if (document) return { view: "docs", documentId: document[1] };
  const invite = start.match(/^invite_([a-zA-Z0-9_-]+)$/);
  if (invite) return { view: "projects", inviteCode: invite[1] };
  const project = miniAppProjectTarget(start);
  return project
    ? {
        projectId: project.projectId,
        view: project.view === "board" ? "tasks" : project.view,
      }
    : null;
}

export function miniAppTaskTarget(
  start: string | undefined,
  params: URLSearchParams,
) {
  const legacy = start ? botStartTarget(start)?.taskId : undefined;
  const task = legacy || params.get("task");
  return task && /^[a-zA-Z0-9-]{1,100}$/.test(task) ? task : null;
}
